import { SeverityType, WarningModel } from './warningDefinitions';

export const getSeverityType = (warnings: WarningModel[]): SeverityType => {
  if (warnings.find(w => w.severity === SeverityType.CRITICAL || w.severity === SeverityType.SEMICRITICAL)) {
    return SeverityType.CRITICAL;
  }

  if (warnings.length > 0) {
    return SeverityType.WARNING;
  }

  return SeverityType.NONE;
};
